import { toast } from 'react-toastify';
import {
    commentOnTicket,
    editTicket,
    getTicketById,
    sendEmail,
    ticketsCountFun,
    ticketsInfo
} from '../../../api/supportAPI';
import errorHandle from '../../../utils/errorHandle';
import { supAdminTicket, supAssignTicket, supUserList } from '../../../api/supportAdmin';

export const fetchTickets = async (setLoading, setTicketsData, type, status) => {
    setLoading(true);
    try {
        const tickets = await ticketsInfo(type, status);
        setTicketsData(tickets.data);
        setLoading(false);
    } catch (error) {
        errorHandle(error);
        setLoading(false);
    }
};

export const fetchTicketById = async (setLoading, setTicketData, id, setAssignedUser) => {
    setLoading(true);
    try {
        const tickets = await getTicketById(id);
        setTicketData(tickets.data);
        setAssignedUser(tickets.data.assignedTo);
        setLoading(false);
    } catch (error) {
        errorHandle(error);
        setLoading(false);
    }
};

export const ticketsCount = (setTotalCount, type, setLoading) => {
    setLoading(true);
    try {
        ticketsCountFun(type).then((res) => {
            setLoading(false);
            setTotalCount(res.data.count);
        });
    } catch (error) {
        setLoading(false);
        errorHandle(error);
    }
};

export const sendMessage = async (type, id, setLoading) => {
    try {
        setLoading(true);
        const res = await sendEmail(type, id);
        if (res.status === 200) {
            setLoading(false);
            toast.success('Message sent sucessfully');
        }
    } catch (error) {
        setLoading(false);
    }
};

export const updateTicket = async (type, id, data, setDescription, setDescModal, setLoading, actionType, refresh) => {
    try {
        setLoading(true);
        const res = await editTicket(type, id, data);
        if (res.status === 200) {
            setLoading(false);
            setDescModal(false);
            setDescription('');
            refresh();
            if (actionType === 'close') toast.success('Ticket Closed successfully');
            else if (actionType === 'open') toast.success('Ticket Reopened successfully');
            else toast.success('Description updated successfully');
        }
    } catch (error) {
        setLoading(false);
        setDescription('');
    }
};

export const addComment = async (type, id, data, setComment, setLoading, refresh) => {
    try {
        setLoading(true);
        const res = await commentOnTicket(type, id, data);
        if (res.status === 200) {
            setLoading(false);
            refresh();
            setComment('');
            toast.success('Commented sucessfully');
        }
    } catch (error) {
        setLoading(false);
    }
};

export const getUsers = async (setUserList, setLoading) => {
    setLoading(true);
    try {
        const users = await supUserList();
        setUserList(users.data);
        setLoading(false);
    } catch (error) {
        errorHandle(error);
        setLoading(false);
    }
};

export const updateAssignee = async (type, id, data, setAssignedUser, setAssignModal, setLoading, refresh) => {
    try {
        setLoading(true);
        const res = await supAssignTicket(type, id, data);
        if (res.status === 200) {
            setLoading(false);
            setAssignedUser('');
            setAssignModal(false);
            refresh();
            toast.success('Assignee updated sucessfully');
        }
    } catch (error) {
        setLoading(false);
        setAssignedUser('');
    }
};

export const fetchAdminTickets = async (setLoading, setTicketsData, type, status, assignedTo, createdBy) => {
    setLoading(true);
    try {
        if (assignedTo === 'Select') return;
        const tickets = await supAdminTicket(type, status, assignedTo, createdBy);
        setTicketsData(tickets.data);
        setLoading(false);
    } catch (error) {
        errorHandle(error);
        setLoading(false);
    }
};
